<div class="automation-rule-action-form">
  <form [formGroup]="form">
    <div formArrayName="actions">
      <ng-container
        *ngFor="
          let actionControl of actionsFormArray?.controls;
          trackBy: trackByControlValue;
          let i = index
        "
      >
        <div *ngIf="i !== 0" class="custom-divider mt-4"></div>

        <div class="flex">
          <div class="actions-form__content flex-grow-1 gap-4" [formGroupName]="i">
            <div class="form-group w-p20">
              <div class="lum-label">Actions</div>
              <mat-select
                class="lum-select"
                formControlName="action"
                [ngClass]="{
                  error:
                    actionControl.get('action')?.invalid &&
                    actionControl.get('action')?.touched,
                }"
              >
                <mat-option
                  *ngFor="
                    let action of availableActions;
                    trackBy: trackById
                  "
                  [value]="action.id"
                  (click)="onActionChange(action.id, i)"
                >
                  {{ action.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="actionControl.get('action')?.invalid">
                <small>
                  {{ actionControl.get('action') | validateField }}
                </small>
              </mat-error>
            </div>

            <ng-container [ngSwitch]="actionControl?.value?.action">
              <div *ngSwitchCase="eAutomationRuleActions.ASSIGN_TAG" class="w-p50">
                <lum-filter-tag
                  [value]="actionControl?.value?.assignTag?.tags"
                  [inlineChips]="true"
                  (onFilterSelect)="onSelectTag($event, i)"
                  [ngClass]="{
                    'filtag-tag-error':
                      actionControl.get('assignTag')?.get('tags')?.invalid &&
                      actionControl.get('assignTag')?.get('tags')?.touched,
                  }"
                ></lum-filter-tag>
                <mat-error
                  *ngIf="
                    actionControl.get('assignTag')?.get('tags')?.invalid &&
                    actionControl.get('assignTag')?.get('tags')?.touched
                  "
                >
                  <small> This field is required </small>
                </mat-error>
              </div>

              <!-- UPDATE COLUMN -->
              <ng-container
                *ngSwitchCase="eAutomationRuleActions.UPDATE_COLUMN"
                formGroupName="updateColumn"
              >
                <!-- Column Update Fields -->
                <div class="form-group w-p20">
                  <div class="lum-label">Field</div>
                  <mat-select
                    class="lum-select"
                    formControlName="field"
                    [ngClass]="{
                      error:
                        actionControl.get('updateColumn')?.get('field')?.invalid &&
                        actionControl.get('updateColumn')?.get('field')?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let field of automationRuleConfig.updateColumnFields;
                        trackBy: trackById
                      "
                      [value]="field.id"
                      (click)="columnFieldValues(field.id)"
                    >
                      {{ field.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <ng-container
                  *ngIf="
                    actionControl?.value?.updateColumn?.field?.includes('custom');
                    else fieldElse
                  "
                >
                  <!-- Column Update Custom Field values -->
                  <div class="form-group w-p20">
                    <div class="lum-label">Custom Field</div>
                    <mat-select
                      class="lum-select"
                      formControlName="customField"
                      [ngClass]="{
                        error:
                          actionControl.get('updateColumn')?.get('type')?.invalid &&
                          actionControl.get('updateColumn')?.get('type')?.touched,
                      }"
                    >
                      <mat-option
                        *ngFor="let customField of customFields; trackBy: trackById"
                        [value]="'custom_field_' + customField.label"
                        (click)="onClickCustomField(customField, i)"
                      >
                        {{ customField.label }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="form-group w-p20">
                    <div class="lum-label">Value</div>
                    <ng-container
                      [ngSwitch]="
                        actionControl.get('updateColumn')?.get('type')?.value
                      "
                    >
                      <ng-container *ngSwitchCase="fieldType.NUMBER">
                        <input
                          type="number"
                          class="lum-input"
                          formControlName="value"
                          tool-tip-trigger="focusin"
                          tool-tip-hid-trigger="focusout"
                          [ngClass]="{
                            error:
                              actionControl.get('updateColumn')?.get('value')
                                ?.invalid &&
                              actionControl.get('updateColumn')?.get('value')
                                ?.touched,
                          }"
                          [matTooltip]="contextValues"
                        />
                      </ng-container>
                      <ng-container *ngSwitchCase="fieldType.DATE">
                        <mat-form-field class="lum-datepicker-field w-100">
                          <input
                            matInput
                            [matDatepicker]="orderDatepicker"
                            formControlName="value"
                            [ngClass]="{
                              error:
                                actionControl.get('updateColumn')?.get('value')
                                  ?.invalid &&
                                actionControl.get('updateColumn')?.get('value')
                                  ?.touched,
                            }"
                          />
                          <mat-datepicker-toggle
                            matSuffix
                            [for]="orderDatepicker"
                            [ngClass]="{
                              error:
                                actionControl.get('updateColumn')?.get('value')
                                  ?.invalid &&
                                actionControl.get('updateColumn')?.get('value')
                                  ?.touched,
                            }"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #orderDatepicker></mat-datepicker>
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngSwitchCase="fieldType.DROPDOWN">
                        <lum-ui-autocomplete
                          [options]="
                            actionControl.get('updateColumn')?.get('options')
                              ?.value ?? []
                          "
                          [displayProperty]="'value'"
                          [ngClass]="{
                            error:
                              actionControl.get('updateColumn')?.get('value')
                                ?.invalid &&
                              actionControl.get('updateColumn')?.get('value')
                                ?.touched,
                          }"
                          [control]="
                            actionControl.get('updateColumn')?.get('value')
                          "
                          (inputChangeEvent)="onDropdownInputChangeEvent($event, i)"
                        ></lum-ui-autocomplete>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <input
                          type="text"
                          class="lum-input"
                          formControlName="value"
                          tool-tip-trigger="focusin"
                          tool-tip-hid-trigger="focusout"
                          [ngClass]="{
                            error:
                              actionControl.get('updateColumn')?.get('value')
                                ?.invalid &&
                              actionControl.get('updateColumn')?.get('value')
                                ?.touched,
                          }"
                          [matTooltip]="contextValues"
                        />
                      </ng-container>
                    </ng-container>
                    <mat-error
                      *ngIf="
                        actionControl.get('updateColumn')?.get('value')?.invalid
                      "
                    >
                      <small>
                        {{
                          actionControl.get('updateColumn')!.get('value')
                            | validateField
                        }}
                      </small>
                    </mat-error>
                  </div>
                </ng-container>
                <ng-template #fieldElse>
                  <ng-container
                    *ngIf="
                      actionControl?.value?.updateColumn?.field?.includes('Color');
                      else valueElse
                    "
                  >
                    <div class="form-group w-p20">
                      <div class="lum-label">Value</div>
                      <input
                        type="text"
                        class="lum-input"
                        formControlName="value"
                        [ngClass]="{
                          error:
                            actionControl.get('updateColumn')?.get('value')
                              ?.invalid &&
                            actionControl.get('updateColumn')?.get('value')
                              ?.touched,
                        }"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'right'"
                        [cpPositionOffset]="'25'"
                        [cpPositionRelativeToArrow]="true"
                        [cpCancelButton]="true"
                        [cpOKButton]="true"
                        [cpOKButtonText]="'Apply'"
                        [cpSaveClickOutside]="true"
                        [cpFallbackColor]="selectedColor"
                        [(colorPicker)]="selectedColor"
                        (colorPickerChange)="onColorPickerChange($event)"
                      />
                      <mat-error
                        *ngIf="
                          actionControl.get('updateColumn')?.get('value')?.invalid
                        "
                      >
                        <small>
                          {{
                            actionControl.get('updateColumn')!.get('value')
                              | validateField
                          }}
                        </small>
                      </mat-error>
                    </div>
                  </ng-container>
                  <ng-template #valueElse>
                    <!-- Column Update Field values -->
                    <div class="form-group w-p20">
                      <div class="lum-label">Value</div>
                      <mat-select
                        class="lum-select"
                        formControlName="value"
                        [ngClass]="{
                          error:
                            actionControl.get('updateColumn')?.get('value')
                              ?.invalid &&
                            actionControl.get('updateColumn')?.get('value')
                              ?.touched,
                        }"
                      >
                        <mat-option
                          *ngFor="let value of columnFields; trackBy: trackById"
                          [value]="value.id"
                        >
                          {{ value.name || value.label }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-container>

              <ng-container
                *ngSwitchCase="eAutomationRuleActions.AGGREGATE_RELATIONSHIP"
                formGroupName="aggregateRelationship"
              >
                <div class="form-group w-p20">
                  <div class="lum-label">Relation</div>
                  <mat-select
                    class="lum-select"
                    formControlName="relation"
                    [ngClass]="{
                      error:
                        actionControl.get('aggregateRelation')?.get('relation')
                          ?.invalid &&
                        actionControl.get('aggregateRelation')?.get('relation')
                          ?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let relation of automationRuleConfig.aggregateRelations;
                        trackBy: trackById
                      "
                      [value]="relation.id"
                      (click)="onRelationChange(relation.context)"
                    >
                      {{ relation.name }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="form-group w-p20">
                  <div class="lum-label">Aggregation Type</div>
                  <mat-select
                    class="lum-select"
                    formControlName="aggregate"
                    [ngClass]="{
                      error:
                        actionControl.get('aggregateRelation')?.get('aggregate')
                          ?.invalid &&
                        actionControl.get('aggregateRelation')?.get('aggregate')
                          ?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let type of automationRuleConfig.aggregateTypes;
                        trackBy: trackById
                      "
                      [value]="type.id"
                      (click)="getContextValues()"
                    >
                      {{ type.name }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="form-group w-p20">
                  <div class="lum-label">Attribute</div>
                  <mat-select
                    class="lum-select"
                    formControlName="attribute"
                    [ngClass]="{
                      error:
                        actionControl.get('aggregateRelation')?.get('attribute')
                          ?.invalid &&
                        actionControl.get('aggregateRelation')?.get('attribute')
                          ?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let attribute of aggregateAttributes;
                        trackBy: trackById
                      "
                      [value]="attribute.id"
                      (click)="getContextValues()"
                    >
                      {{ attribute.name }}
                    </mat-option>
                  </mat-select>
                </div>
              </ng-container>

              <ng-container
                *ngSwitchCase="eAutomationRuleActions.EMAIL"
                formGroupName="email"
              >
                <div class="form-group w-p50">
                  <span
                    style="position: fixed"
                    #spanTrigger
                    class="context-menu-trigger"
                    #matTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="menu"
                    #menuTrigger="matMenuTrigger"
                  >
                  </span>
                  <div class="lum-label">Template</div>
                  <textarea
                    class="lum-input"
                    formControlName="template"
                    (contextmenu)="contextEvent($event, menuTrigger, spanTrigger)"
                    [ngClass]="{
                      error:
                        actionControl.get('email')?.get('template')?.invalid &&
                        actionControl.get('email')?.get('template')?.touched,
                    }"
                  ></textarea>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item [matMenuTriggerFor]="variables">
                      Insert Variables
                    </button>
                  </mat-menu>
                  <mat-menu #variables="matMenu">
                    <button
                      mat-menu-item
                      (click)="insertVariable($event, 'orderNumber')"
                    >
                      Order Number
                    </button>
                    <button
                      mat-menu-item
                      (click)="insertVariable($event, 'invoiceId')"
                    >
                      Invoice ID
                    </button>
                  </mat-menu>
                  <mat-error
                    *ngIf="actionControl.get('email')?.get('template')?.invalid"
                  >
                    <small>
                      {{
                        actionControl.get('email')!.get('template') | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
                <div class="form-group w-p20">
                  <div class="lum-label">Email</div>
                  <input
                    type="text"
                    class="lum-input"
                    formControlName="email"
                    [ngClass]="{
                      error:
                        actionControl.get('email')?.get('email')?.invalid &&
                        actionControl.get('email')?.get('email')?.touched,
                    }"
                  />
                  <mat-error
                    *ngIf="actionControl.get('email')?.get('email')?.invalid"
                  >
                    <small>
                      {{ actionControl.get('email')!.get('email') | validateField }}
                    </small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Hold Order Action -->
              <ng-container
                *ngSwitchCase="eAutomationRuleActions.HOLD_ORDER"
                formGroupName="holdOrder"
              >
                <div class="form-group w-p20">
                  <div class="lum-label">Hold Type</div>
                  <mat-select
                    class="lum-select"
                    formControlName="holdType"
                    [ngClass]="{
                      error:
                        actionControl.get('holdOrder')?.get('holdUntil')?.invalid &&
                        actionControl.get('holdOder')?.get('holdType')?.touched,
                    }"
                  >
                    <mat-option value="duration"> Duration (Minutes) </mat-option>
                    <mat-option value="date"> Date </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="actionControl.get('holdOrder')?.get('holdType')?.invalid"
                  >
                    <small>
                      {{
                        actionControl.get('holdOrder')!.get('holdType')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
                <!-- Date Selector -->
                <div
                  *ngIf="
                    !actionControl.get('holdOrder')?.get('holdType')?.invalid &&
                    actionControl?.value?.holdOrder?.holdType == 'date'
                  "
                  class="form-group w-p20"
                >
                  <div class="lum-label">Date</div>
                  <mat-form-field class="lum-datepicker-field w-100">
                    <input
                      matInput
                      [matDatepicker]="holdUntilDatepicker"
                      formControlName="holdUntil"
                      [ngClass]="{
                        error:
                          actionControl.get('holdOrder')?.get('holdType')
                            ?.invalid &&
                          actionControl.get('holdOrder')?.get('holdType')?.touched,
                      }"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="holdUntilDatepicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #holdUntilDatepicker></mat-datepicker>
                  </mat-form-field>
                  <mat-error
                    *ngIf="actionControl.get('holdOrder')?.get('holdType')?.invalid"
                  >
                    <small>
                      {{
                        actionControl.get('holdOrder')!.get('holdType')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
                <div
                  *ngIf="
                    !actionControl.get('holdOrder')?.get('holdType')?.invalid &&
                    actionControl?.value?.holdOrder?.holdType == 'duration'
                  "
                  class="form-group w-p20"
                >
                  <div class="lum-label">Duration (Minutes)</div>
                  <input
                    type="text"
                    class="lum-input"
                    formControlName="holdUntil"
                    [ngClass]="{
                      error:
                        actionControl.get('holdOrder')?.get('holdUntil')?.invalid &&
                        actionControl.get('holdOrder')?.get('holdUntil')?.touched,
                    }"
                  />
                  <mat-error
                    *ngIf="
                      actionControl.get('holdOrder')?.get('holdUntil')?.invalid
                    "
                  >
                    <small>
                      {{
                        actionControl.get('holdOrder')!.get('attribute')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
              </ng-container>

              <div
                *ngSwitchCase="
                  eAutomationRuleActions.SEND_UNALLOCATED_ORDERS_IN_PURGATORY_EMAIL
                "
                class="lum-c-automation-rule-action-form__send-unallocated-orders w-p50"
              >
                <lum-filter-user-groups
                  [value]="
                    actionControl?.value?.sendUnallocatedOrdersInPurgatoryEmail
                      ?.userGroups
                  "
                  [inlineChips]="true"
                  (onFilterSelect)="onSelectUserGroupUnallocatedOrders($event, i)"
                ></lum-filter-user-groups>
                <mat-error
                  *ngIf="
                    actionControl
                      .get('sendUnallocatedOrdersInPurgatoryEmail')
                      ?.get('userGroups')?.invalid &&
                    actionControl
                      .get('sendUnallocatedOrdersInPurgatoryEmail')
                      ?.get('userGroups')?.touched
                  "
                >
                  <small> This field is required </small>
                </mat-error>
              </div>

              <div
                *ngSwitchCase="eAutomationRuleActions.SEND_INBOUND_SHIPMENT_EMAIL"
                class="lum-c-automation-rule-action-form__send-inbound-shipments w-p50"
              >
                <lum-filter-user-groups
                  [value]="
                    actionControl?.value?.sendInboundShipmentEmail?.userGroups
                  "
                  [inlineChips]="true"
                  (onFilterSelect)="onSelectUserGroupInboundShipment($event, i)"
                ></lum-filter-user-groups>
                <mat-error
                  *ngIf="
                    actionControl.get('sendInboundShipmentEmail')?.get('userGroups')
                      ?.invalid &&
                    actionControl.get('sendInboundShipmentEmail')?.get('userGroups')
                      ?.touched
                  "
                >
                  <small> This field is required </small>
                </mat-error>
              </div>
            </ng-container>
          </div>
          <button
            (click)="onRemoveAction(i)"
            mat-icon-button
            color="warn"
            type="button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </form>

  <div class="flex justify-content-end mt-4">
    <button
      type="button"
      class="lum-button lum-button--secondary"
      (click)="onAddActionRow()"
    >
      <lum-ui-icon class="mr-2" icon="add-1" color="#5563d6"></lum-ui-icon>
      Add Action
    </button>
  </div>
</div>
